import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { GoogleMapComponent } from './google-map/google-map.component';
import { environment } from '../../environments/environment';
import { MrtTrafficComponent } from './triffic-detail/mrt-traffic.component';
import { ThsrTrafficComponent } from './triffic-detail/thsr-traffic.component';
import { TraTrafficComponent } from './triffic-detail/tra-traffic.component';
import { BusTrafficComponent } from './triffic-detail/bus-traffic.component';
import { BikeTrafficComponent } from './triffic-detail/bike-traffic.component';
import { NhptTrafficComponent } from './triffic-detail/nhpt-traffic.component';

@Component({
  selector: 'map-traffic',
  standalone: true,
  imports: [GoogleMapComponent, MrtTrafficComponent, ThsrTrafficComponent,TraTrafficComponent,BusTrafficComponent,NhptTrafficComponent,BikeTrafficComponent],
  styleUrl: '../../static/css/traffic.css',
  templateUrl: './map-traffic.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MapTrafficComponent {
  name: string;
  type: string;
  stationId: string;
  state:string ="ALL"

  // [mapComponent] 子組件
  @ViewChild(GoogleMapComponent) mapComponent: GoogleMapComponent;


  /**
  * ngOnInit[初始化後呼叫]
  */
  ngOnInit(){
    this.name = environment?.name
  }

  /**
  * ngAfter[視圖加載後自動呼叫]
  * (Action) 呼叫 [mapComponent] 底下的 getLocal()
  */
  ngAfterViewInit() {
    this.mapComponent.getLocal();
  }


  /**
  * function
  * (Action) 呼叫 [mapComponent] 底下的 getLocal()
  */
  callMap_getLocal() {
    this.mapComponent.getLocal();

  }


  showMarker(state:string){
    this.state = state;
    this.mapComponent.type = state;
  }


  showDetail(type:string,name:string,stationId:string){
    this.name = name;
    this.stationId = stationId;
    this.type = type;
  }


  close(){
    this.type = "close";
    this.name = "";
    this.type = "";
    this.stationId = "";
  }

}
